/** Fallback when site_settings.site_admin_title is empty (matches backend default). */
export const DEFAULT_ADMIN_DOCUMENT_TITLE = 'INVINCIBLE - Admin Panel';
